/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './InfolettreSidebar.css';
import fetch from '../../core/fetch';
import $ from 'jquery';

var validate = '';


@withStyles(s)
export default class InfolettreSidebar extends Component{

    constructor(props) {
        super(props);

        this.state = {
            formData: [],
            nom: '',
            courriel: '',
            success: false,
            validate: false,
            error: false,
        }

        this.updateStateNom = this.updateStateNom.bind(this);
        this.updateStateCourriel = this.updateStateCourriel.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.validateInput = this.validateInput.bind(this);

    }

    componentDidMount(){
        
        
    }

    updateStateNom(e) {
      
        this.setState({nom: e.target.value});

    }

    updateStateCourriel(e) {
      
        this.setState({courriel: e.target.value});

    }

    validateInput() {

        validate = false;

        if(this.refs.nom.value == ''){
            self = this.refs.nom;
            $(self).addClass('borderRed'); 
            validate = !this.state.validate;
        }
        if(this.refs.nom.value != ''){
            self = this.refs.nom;
            $(self).removeClass('borderRed');
        }
        if(this.refs.courriel.value == ''){
            self = this.refs.courriel;
            $(self).addClass('borderRed');
            validate = !this.state.validate;
        }
        if(this.refs.courriel.value != ''){
            self = this.refs.courriel;
            $(self).removeClass('borderRed');
        }
        
        if(validate) {
            $('.messageError').css('color', 'red');
        }

        return validate;
    }

    submitForm(e){

        e.preventDefault();

        validate = this.validateInput();

        var form = document.getElementById('formInfolettre');
        var formData = new FormData(form);
        var url = 'http://agenceprolifik.ca/graphql/index.php'

        
        if(validate){

            
        }
        else{

            $.ajax({
                url: url,
                type: "POST",
                data: formData,
                mimeType: "multipart/form-data",
                contentType: false,
                crossDomain: true,
                dataType: "json",
                cache: false,
                processData:false,
                success: function(data, textStatus, jqXHR)
                {
                    
                    this.setState({success: true});

                }.bind(this),
                error: function(jqXHR, textStatus, errorThrown) 
                {

                    console.log('echec');

                }.bind(this)          
            });
        }
    }

    render(){

        if(!this.state.success){

            var content =   <div className={`infolettre`}>
                                <span className={`titreSectionSidebar`}>Infolettre</span>
                                <div className={`content`}>
                                    <span className={`texteInfolettre`}>Recevez nos conseils et guides pratiques en stratégie web en exclusivité !</span>
                                    <div className={`wrapForm`}>
                                        <form id="formInfolettre" onSubmit={this.submitForm} className={`formContact`}>
                                            <input type="hidden" name="infolettre" />
                                            <div className={`wrapInput`}>
                                                <input type="text" name="nom" id="nom" ref="nom" className={`inputText`} placeholder="Nom" onChange={this.updateStateNom} value={this.state.nom} />
                                            </div>
                                            <div className={`wrapInput`}>
                                                <input type="email" name="courriel" id="courriel" ref="courriel" className={`inputText`} placeholder="Courriel" onChange={this.updateStateCourriel} value={this.state.courriel} />
                                            </div>
                                            <div className={`wrapInput`}>
                                                <span className={`messageError`}>
                                                    * Tous les champs sont obligatoires !
                                                </span>
                                            </div>
                                            <div className={`wrapInput`}>
                                                <input type="submit" value="S'inscrire" className={`inputSubmit`} />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        
        }
        else{
            var content =   <div className={`infolettre`}>
                                <span className={`titreSectionSidebar`}>Infolettre</span>
                                <div className={`content`}>
                                    <span className={`texteInfolettre`}>Merci de votre intérêt !</span>
                                </div>
                            </div>
        }
        return (
            <div className={s.root}>
                {content}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/InfolettreSidebar/InfolettreSidebar.js